import { CoverageDetailsProps } from "../../../../types/components/coverageDetails.types";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import { useRef, useState } from "react";
import { useCallback } from "react";
import { useContext, useEffect } from "react";
import { PaycheckContext, ThemeContext } from "../../../../contexts";

const CoverageDetails = ({ coverageDetails, titleHeader, choosePlanText }: CoverageDetailsProps): JSX.Element => {
	console.log("coverageDetails=======>", coverageDetails);
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef<any>(null);
	const { paycheck } = useContext(PaycheckContext);
	const { theme } = useContext(ThemeContext);
	// console.log("coverageDetails kks", coverageDetails);
	const handleAgGridReady = (params: GridReadyEvent) => {
		params.api.sizeColumnsToFit();
	};

	const premiumValueCellRenderer = useCallback(
		(value: any) => {
			// console.log("value", value);
			return `${value.value} of ${paycheck?.pay_frequency} Base Pay`;
		},
		[paycheck?.pay_frequency]
	);

	// console.log("grid-length", coverageDetails.length);

	useEffect(() => {
		switch (coverageDetails.length) {
			case 0: {
				setGridHeight("110px");
				break;
			}
			case 1: {
				setGridHeight("110px");
				break;
			}
			case 2: {
				setGridHeight("160px");
				break;
			}
			case 3: {
				setGridHeight("200px");
				break;
			}
			case 4: {
				setGridHeight("240px");
				break;
			}
			case 5: {
				setGridHeight("280px");
				break;
			}
		}
	}, [coverageDetails.length]);

	// console.log("==>coverage details", coverageDetails);

	return (
		<div className="coverage-details">
			<div className="header-container">
				<div className="theme-plan-header">{titleHeader ? titleHeader : "Plans"}</div>
				<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
					{choosePlanText}
				</div>
			</div>
			<div className="theme-plan-inner-section-margin" />
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					rowData={coverageDetails}
					onGridReady={handleAgGridReady}
					animateRows
					rowDragManaged
					defaultColGroupDef={{ marryChildren: true }}
					rowSelection="single"
					enableCellChangeFlash={true}
					frameworkComponents={{
						premiumValueCellRenderer
					}}
				>
					<AgGridColumn field="coverage" headerName="Coverage"></AgGridColumn>
					<AgGridColumn
						field="premiumAmount"
						headerName="Premium Value"
						cellRenderer="premiumValueCellRenderer"
					></AgGridColumn>
				</AgGridReact>
			</div>
		</div>
	);
};

export default CoverageDetails;
